import React from "react";

const PaymentsRefunds = (props) => {
  const options = [
    {
      text: 'Si j’effectue un paiement au moyen de KONEK et que je retourne ensuite l’article, comment vais-je recevoir le remboursement?',
      handler: props.actionProvider.handlePaymentsRefunds1,
      id: 1,
    },
    {
      text: 'Si j’ai effectué un paiement à l’aide de KONEK et que j’ai sélectionné le mauvais compte bancaire, comment puis-je annuler la commande?',
      handler: props.actionProvider.handlePaymentsRefunds2,
      id: 2
    },
    {
      text: 'Comment puis-je vérifier si mon paiement a été traité?',
      handler: props.actionProvider.handlePaymentsRefunds3,
      id: 3
    },
    {
      text: 'Il y a eu un problème avec mon opération KONEK, avec qui dois-je communiquer?',
      handler: props.actionProvider.handlePaymentsRefunds4,
      id: 4
    },
    {
      text: 'Comment mes renseignements sont-ils protégés dans le cadre de l’utilisation de KONEK?',
      handler: props.actionProvider.handlePaymentsRefunds5,
      id: 5
    },
    {
      text: 'Le commerçant a-t-il accès à mes renseignements bancaires?',
      handler: props.actionProvider.handlePaymentsRefunds6,
      id: 6
    },
    {
      text: 'Comment puis-je me protéger contre la fraude lorsque j’utilise KONEK?',
      handler: props.actionProvider.handlePaymentsRefunds7,
      id: 7
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.text.replace(/\s+/g, '-').toLowerCase()}>
    <input
      type="radio"
      className='consumer-product-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />
    
    <span className={option.text.replace(/\s+/g, '-').toLowerCase()}>{option.text}</span>
      </label>
  ));

  return <div className='consumer-products-container'>{optionsMarkup}</div>;
};

export default PaymentsRefunds;